export const WEBSOCKET_URL =
  process.env.NODE_ENV === 'production' ? '' : 'ws://localhost:3001';

export const TEST = '';
